import { useLocation } from "react-router-dom";
import pages from "./pages.json";
import {
  useSeo,
  breadcrumbJsonLd,
  SITE_URL,
  ORGANIZATION_ID,
} from "./useSeo";

const normalizePath = (pathname) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

// Metadate pentru paginile fixe (definite în pages.json).
// Articolele de blog și pagina 404 își setează singure metadatele.
const RouteSeo = () => {
  const { pathname } = useLocation();
  const path = normalizePath(pathname);
  const page = pages[path];

  let seo = null;
  if (page) {
    const canonicalPath = page.canonical || path;
    const url = `${SITE_URL}${canonicalPath}`;
    const jsonLd = [
      {
        "@type": page.schemaType || "WebPage",
        "@id": `${url}#webpage`,
        url,
        name: page.title,
        description: page.description,
        inLanguage: page.lang,
        isPartOf: { "@id": `${SITE_URL}/#website` },
        about: { "@id": ORGANIZATION_ID },
      },
    ];
    if (canonicalPath !== "/") {
      const crumbs = [{ name: "Travel Time", path: "/" }];
      if (page.parent && pages[page.parent]) {
        crumbs.push({ name: pages[page.parent].name, path: page.parent });
      }
      crumbs.push({ name: page.name, path: canonicalPath });
      jsonLd.push(breadcrumbJsonLd(crumbs));
    }
    seo = {
      title: page.title,
      description: page.description,
      lang: page.lang,
      path: canonicalPath,
      jsonLd,
    };
  }

  useSeo(seo);
  return null;
};

export default RouteSeo;
